export default "__VITE_ASSET__b4b096a0__"